import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=5a8ffb22&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=5a8ffb22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8ffb22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a8ffb22')) {
      api.createRecord('5a8ffb22', component.options)
    } else {
      api.reload('5a8ffb22', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=5a8ffb22&scoped=true&", function () {
      api.rerender('5a8ffb22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/comp/DateRangeExt.vue"
export default component.exports